package com.iregained.site.components.sections.patients.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val HeaderPrimaryActionStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        // adaptaions made for standard button size and color
        Modifier.backgroundColor(palette.brand.primary).color(palette.custom.lightGray)
            .border(1.px, LineStyle.Solid, palette.brand.primary)
            .transition(Transition.of(TransitionProperty.All, duration = 300.ms))
    }
    hover {
        val palette = colorMode.toSitePalette()
        // adaptaions made for primary hover effect
        Modifier.backgroundColor(palette.brand.primaryHover).border(1.px, LineStyle.Solid, palette.brand.primaryHover)
            .translateY((-2).px).boxShadow(0.px, 4.px, 10.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.3f))
    }
}

val HeaderSecondaryActionStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        // adaptaions made for standard secondary button
        Modifier.backgroundColor(palette.nearBackground).color(palette.brand.primary)
            .border(2.px, LineStyle.Solid, palette.brand.primary)
            .transition(Transition.of(TransitionProperty.All, duration = 300.ms))
    }
    hover {
        val palette = colorMode.toSitePalette()
        // adaptaions made for secondary hover effect
        Modifier.backgroundColor(palette.brand.primarySoft).translateY((-2).px)
            .boxShadow(0.px, 4.px, 10.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.2f))
    }
}

val PremiumHeaderImageStyle = CssStyle {

    base {
        val palette = colorMode.toSitePalette()
        // resting state shadow for hero image
        Modifier.boxShadow(0.px, 20.px, 40.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.1f)).transition(
                // adapted premium longer transition
                Transition.of("transform", 0.5.s), Transition.of("box-shadow", 0.5.s)
            )
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier
            // adaptaiones made for premium zoom effect
            .scale(1.02).boxShadow(0.px, 30.px, 60.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.25f))
    }
}